import { ContentType } from "../../models/enums/content-type.enum";
import { Class } from "../../models/interfaces/module-class.interface";
import { Module } from "../../models/interfaces/module.interface";

const MODULE_1 = 'module-1';
const MODULE_2 = 'module-2';
const MODULE_3 = 'module-3';
const MODULE_PO_1 = 'module-po-1';
const MODULE_PO_2 = 'module-po-2';
const MODULE_PO_3 = 'module-po-3';
const TENANT_ID = 'tenant-uuid';
const COURSE_ID = 'course-uuid-4';
const MODULE_TITLE = 'Gestão empresarial';

const MODULE_1_CLASSES = ['module-1-class-1', 'module-1-class-2', 'module-1-class-3', 'module-1-class-4'];
const MODULE_2_CLASSES = ['module-2-class-1', 'module-2-class-2', 'module-2-class-3'];
const MODULE_3_CLASSES = ['module-3-class-1', 'module-3-class-2'];

export const moduleClassMock: Class[] = [
	{
		id: 'module-1-class-1',
		moduleId: MODULE_1,
		title: 'Gestão de Pessoas',
		duration: 35,
		type: ContentType.VIDEO,
		contentId: 'content-module-1-class-1',
		order: 1,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-1-class-2',
		moduleId: MODULE_1,
		title: 'Processos de gestão de pessoas e subsistemas de Recursos Humanos',
		duration: 45,
		type: ContentType.RICH_TEXT,
		contentId: 'content-module-1-class-2',
		order: 2,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-1-class-3',
		moduleId: MODULE_1,
		title: 'Detalhamento dos processos de gestão de pessoas',
		duration: 40,
		type: ContentType.HTML,
		contentId: 'content-module-1-class-3',
		order: 3,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-1-class-4',
		moduleId: MODULE_1,
		title: 'Gestão estratégica de pessoas: o ponto de partida para o desenvolvimento organizacional',
		duration: 35,
		type: ContentType.ACTIVITY,
		contentId: 'content-module-1-class-4',
		order: 4,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-2-class-1',
		moduleId: MODULE_2,
		title: 'Cultura organizacional e liderança',
		duration: 40,
		type: ContentType.VIDEO,
		contentId: 'content-module-2-class-1',
		order: 1,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-2-class-2',
		moduleId: MODULE_2,
		title: 'Planejamento de carreira e desenvolvimento',
		duration: 35,
		type: ContentType.RICH_TEXT,
		contentId: 'content-module-2-class-2',
		order: 2,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-2-class-3',
		moduleId: MODULE_2,
		title: 'Avaliação do módulo: liderança e desenvolvimento',
		duration: 30,
		type: ContentType.ACTIVITY,
		contentId: 'content-module-2-class-3',
		order: 3,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-3-class-1',
		moduleId: MODULE_3,
		title: 'Indicadores e métricas de desempenho',
		duration: 30,
		type: ContentType.HTML,
		contentId: 'content-module-3-class-1',
		order: 1,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-3-class-2',
		moduleId: MODULE_3,
		title: 'Plano de ação para melhoria contínua',
		duration: 30,
		type: ContentType.ACTIVITY,
		contentId: 'content-module-3-class-2',
		order: 2,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-po-1-class-1',
		moduleId: MODULE_PO_1,
		title: 'O que é cultura de aprendizagem',
		duration: 15,
		type: ContentType.RICH_TEXT,
		contentId: 'content-module-po-1-class-1',
		order: 1,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-po-1-class-2',
		moduleId: MODULE_PO_1,
		title: 'Como criar uma cultura de aprendizagem',
		duration: 20,
		type: ContentType.VIDEO,
		contentId: 'content-module-po-1-class-2',
		order: 2,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-po-1-class-3',
		moduleId: MODULE_PO_1,
		title: 'Da capacitação pontual à aprendizagem contínua',
		duration: 18,
		type: ContentType.RICH_TEXT,
		contentId: 'content-module-po-1-class-3',
		order: 3,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-po-1-class-4',
		moduleId: MODULE_PO_1,
		title: 'Avaliação: cultura de aprendizagem',
		duration: 20,
		type: ContentType.ACTIVITY,
		contentId: 'content-module-po-1-class-4',
		order: 4,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-po-2-class-1',
		moduleId: MODULE_PO_2,
		title: 'Aprendizagem no fluxo de trabalho',
		duration: 25,
		type: ContentType.VIDEO,
		contentId: 'content-module-po-2-class-1',
		order: 1,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-po-2-class-2',
		moduleId: MODULE_PO_2,
		title: 'Trilhas, microlearning e engajamento',
		duration: 18,
		type: ContentType.RICH_TEXT,
		contentId: 'content-module-po-2-class-2',
		order: 2,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-po-2-class-3',
		moduleId: MODULE_PO_2,
		title: 'Práticas de engajamento em capacitação',
		duration: 15,
		type: ContentType.RICH_TEXT,
		contentId: 'content-module-po-2-class-3',
		order: 3,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-po-2-class-4',
		moduleId: MODULE_PO_2,
		title: 'Avaliação: engajamento e desenvolvimento',
		duration: 20,
		type: ContentType.ACTIVITY,
		contentId: 'content-module-po-2-class-4',
		order: 4,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-po-3-class-1',
		moduleId: MODULE_PO_3,
		title: 'Como medir o impacto da capacitação',
		duration: 18,
		type: ContentType.RICH_TEXT,
		contentId: 'content-module-po-3-class-1',
		order: 1,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-po-3-class-2',
		moduleId: MODULE_PO_3,
		title: 'Painel de indicadores de capacitação',
		duration: 15,
		type: ContentType.RICH_TEXT,
		contentId: 'content-module-po-3-class-2',
		order: 2,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-po-3-class-3',
		moduleId: MODULE_PO_3,
		title: 'Aprendizagem contínua e relevância profissional',
		duration: 15,
		type: ContentType.VIDEO,
		contentId: 'content-module-po-3-class-3',
		order: 3,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: 'module-po-3-class-4',
		moduleId: MODULE_PO_3,
		title: 'Avaliação: resultados e melhoria contínua',
		duration: 20,
		type: ContentType.ACTIVITY,
		contentId: 'content-module-po-3-class-4',
		order: 4,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
];

const joinClasses = (classesIds: string[]): Class[] => {
	return moduleClassMock
		.filter((moduleClass) => classesIds.includes(moduleClass.id))
		.sort((first, second) => first.order - second.order);
};

const sumDuration = (classes: Class[]): number => {
	return classes.reduce((accumulator, moduleClass) => accumulator + moduleClass.duration, 0);
};

const MODULE_PO_1_CLASSES = [
	'module-po-1-class-1',
	'module-po-1-class-2',
	'module-po-1-class-3',
	'module-po-1-class-4',
];
const MODULE_PO_2_CLASSES = [
	'module-po-2-class-1',
	'module-po-2-class-2',
	'module-po-2-class-3',
	'module-po-2-class-4',
];
const MODULE_PO_3_CLASSES = [
	'module-po-3-class-1',
	'module-po-3-class-2',
	'module-po-3-class-3',
	'module-po-3-class-4',
];
const PO_COURSE_ID = 'course-uuid-po';

export const moduleMock: Module[] = [
	{
		id: MODULE_1,
		tenantId: TENANT_ID,
		courseId: COURSE_ID,
		title: MODULE_TITLE,
		classesIds: MODULE_1_CLASSES,
		classes: joinClasses(MODULE_1_CLASSES),
		duration: sumDuration(joinClasses(MODULE_1_CLASSES)),
		order: 1,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: MODULE_2,
		tenantId: TENANT_ID,
		courseId: COURSE_ID,
		title: MODULE_TITLE,
		classesIds: MODULE_2_CLASSES,
		classes: joinClasses(MODULE_2_CLASSES),
		duration: sumDuration(joinClasses(MODULE_2_CLASSES)),
		order: 2,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: MODULE_3,
		tenantId: TENANT_ID,
		courseId: COURSE_ID,
		title: MODULE_TITLE,
		classesIds: MODULE_3_CLASSES,
		classes: joinClasses(MODULE_3_CLASSES),
		duration: sumDuration(joinClasses(MODULE_3_CLASSES)),
		order: 3,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: MODULE_PO_1,
		tenantId: TENANT_ID,
		courseId: PO_COURSE_ID,
		title: 'Cultura de aprendizagem',
		classesIds: MODULE_PO_1_CLASSES,
		classes: joinClasses(MODULE_PO_1_CLASSES),
		duration: sumDuration(joinClasses(MODULE_PO_1_CLASSES)),
		order: 1,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: MODULE_PO_2,
		tenantId: TENANT_ID,
		courseId: PO_COURSE_ID,
		title: 'Engajamento de equipes',
		classesIds: MODULE_PO_2_CLASSES,
		classes: joinClasses(MODULE_PO_2_CLASSES),
		duration: sumDuration(joinClasses(MODULE_PO_2_CLASSES)),
		order: 2,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
	{
		id: MODULE_PO_3,
		tenantId: TENANT_ID,
		courseId: PO_COURSE_ID,
		title: 'Resultados e melhoria contínua',
		classesIds: MODULE_PO_3_CLASSES,
		classes: joinClasses(MODULE_PO_3_CLASSES),
		duration: sumDuration(joinClasses(MODULE_PO_3_CLASSES)),
		order: 3,
		createdAt: new Date(),
		updatedAt: new Date(),
		isActive: true,
	},
];
